<template>
  <div class="content">
    <!-- 咨询服务弹窗 -->
    <el-dialog
      v-model="consultationDialogVisible"
      title="咨询服务"
      width="500px"
      :before-close="handleConsultationClose"
      class="consultation-dialog"
    >
      <div class="dialog-form-content">
        <el-form ref="consultationForm" :model="consultationForm" label-position="top" :rules="consultationRules">
          <el-form-item label="企业名称" prop="companyName">
            <el-input v-model="consultationForm.companyName" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contactPerson">
            <el-input v-model="consultationForm.contactPerson" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input v-model="consultationForm.contactPhone" placeholder="请输入您的联系电话"></el-input>
          </el-form-item>
          <el-form-item label="咨询内容" prop="consultationContent">
            <el-input 
              v-model="consultationForm.consultationContent" 
              type="textarea" 
              :rows="4"
              placeholder="请输入您的咨询内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="submit-btn-dialog" @click="submitConsultation">
              提交
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="margin-left: 8px;">
                <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 顶部横幅 -->
    <div class="banner-section">
      <img src="../assets/img/zscqyyfw/zscqyyfw.png" alt="" class="banner-image">
      <div class="banner-overlay">
        <div class="banner-content">
          <div class="banner-text">
<!--            <p class="banner-subtitle">INTELLECTUAL PROPERTY OPERATION SERVICES</p>-->
            <h1 class="banner-title">知识产权运营服务</h1>
          </div>
        </div>
      </div>
    </div>

    <!-- 服务内容区域 -->
    <div class="services-section">
      <!-- 服务选项卡 -->
      <div class="services-tabs">
        <button 
          v-for="(item, index) in tablists" 
          :key="index"
          :class="['service-tab', { 'active': tabis === item }]"
          @click="tabchange(item)"
        >
          <span class="tab-text">{{ item }}</span>
        </button>
      </div>
      <div class="services-content">
        <div class="content-card">
          <div class="card-left">
            <div class="card-icon">
              <img src="../assets/img/zscqyyfw/Icon.png" alt="" style="width: 80px; height: 80px;">
            </div>
            <h3 class="card-title">{{ tabis }}</h3>
            <div class="title-underline"></div>
<!--            <p class="service-details">SERVICE DETAILS</p>-->
          </div>
          
          <div class="card-right">
            <p class="card-description">{{ content }}</p>
            
            <div class="service-features">
              <div class="feature-item">
                <span class="feature-dot"></span>
                <span>专业团队支持</span>
              </div>
              <div class="feature-item">
                <span class="feature-dot"></span>
                <span>全流程跟踪服务</span>
              </div>
            </div>

            <button class="consult-btn" @click="openConsultationDialog">
              立即咨询
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="margin-left: 8px;">
                <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postAction, getAction } from '@/api/requests'
import Cookies from 'js-cookie'
export default {
  name: 'zscqyyfwContent',
  components: {},
  data(){
    return{
      listnum:0,
      tableData:[],
      tablists:['专利布局','专利价值评估评价','高价值专利组合','产业专利池','专利分析预警','专利导航','知识产权强市强企','专利密集型产品'],
      tabis:'专利布局',
      content:'专利布局是指在对产业、市场以及法律等因素进行综合分析的基础上,有机结合各种专利进而构建一个高效严密的专利保护网,从而使最后形成的专利组合具有有利的格局。专利组合是专利布局的成果,要求具有相当的数量规模,使其具有层级分明、功效齐备的保护网,保障其能在特定的领域中获得专利竞争的优势。',
      consultationDialogVisible: false,
      consultationForm: {
        companyName: '',
        contactPerson: '',
        contactPhone: '',
        consultationContent: ''
      },
      consultationRules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        consultationContent: [
          { required: true, message: '请输入咨询内容', trigger: 'blur' }
        ]
      }
    }
  },
  mounted(){
    this.injectConsultationDialogStyles()
    this.prefillUserInfo()
  },
  methods:{
    prefillUserInfo() {
      const token = Cookies.get('Admin-Token')
      if (!token) return
      getAction('/getInfo').then(res => {
        if (res.code === 200) {
          const u = res.user || {}
          this.consultationForm.companyName = u.enterpriseName || (u.dept && u.dept.deptName) || ''
          this.consultationForm.contactPerson = u.nickName || u.userName || ''
          this.consultationForm.contactPhone = u.phonenumber || ''
        }
      }).catch(() => {})
    },
    injectConsultationDialogStyles() {
      const style = document.createElement('style')
      style.textContent = `
        /* 咨询服务弹窗 */
        .consultation-dialog .el-dialog {
          display: flex;
          flex-direction: column;
        }
        .consultation-dialog .el-dialog__header {
          background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%) !important;
          padding: 24px 32px !important;
          border-radius: 16px 16px 0 0 !important;
          margin: 0 !important;
          flex-shrink: 0;
          position: relative;
          z-index: 10;
        }
        .consultation-dialog .el-dialog__title {
          font-size: 20px !important;
          font-weight: 600 !important;
          color: #FFFFFF !important;
        }
        .consultation-dialog .el-dialog__headerbtn {
          background: rgba(255, 255, 255, 0.2) !important;
          position: absolute;
          top: 24px;
          right: 32px;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 11;
          transition: all 0.3s;
        }
        .consultation-dialog .el-dialog__headerbtn:hover {
          background: rgba(255, 255, 255, 0.3) !important;
          transform: scale(1.1);
        }
        .consultation-dialog .el-dialog__close {
          color: #FFFFFF !important;
          font-size: 18px !important;
          font-weight: bold !important;
        }
        .consultation-dialog .el-dialog__body {
          flex: 1;
          overflow-y: auto;
          padding: 32px;
        }
        .consultation-dialog .el-form-item__label {
          color: #374151;
          font-weight: 500;
        }
        .consultation-dialog .el-input__wrapper {
          border-radius: 8px;
          box-shadow: 0 0 0 1px #E5E7EB inset;
        }
        .consultation-dialog .el-input__wrapper:hover {
          box-shadow: 0 0 0 1px #3B82F6 inset;
        }
        .consultation-dialog .el-input__wrapper.is-focus {
          box-shadow: 0 0 0 2px #3B82F6 inset;
        }
        .consultation-dialog .el-textarea__inner {
          border-radius: 8px;
          border: 1px solid #E5E7EB;
        }
        .consultation-dialog .el-textarea__inner:hover {
          border-color: #3B82F6;
        }
        .consultation-dialog .el-textarea__inner:focus {
          border-color: #3B82F6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }
      `
      document.head.appendChild(style)
    },
    openConsultationDialog() {
      this.consultationDialogVisible = true
    },
    handleConsultationClose() {
      this.consultationDialogVisible = false
      this.$refs.consultationForm.resetFields()
    },
    submitConsultation() {
      this.$refs.consultationForm.validate((valid) => {
        if (valid) {
          postAction('/trade/project_consult/submit', {
            consultContent: this.consultationForm.consultationContent,
            consultDeptName: this.consultationForm.companyName,
            consultType: 'ip_operation',
            contactName: this.consultationForm.contactPerson,
            contactPhone: this.consultationForm.contactPhone
          }).then(res => {
            if (res.code === 200) {
              this.$message.success('咨询申请已提交，我们会尽快与您联系！')
              this.handleConsultationClose()
            } else {
              this.$message.error(res.msg || '提交失败')
            }
          }).catch(() => {
            this.$message.error('提交失败，请稍后重试')
          })
        } else {
          return false
        }
      })
    },
    tabchange(item){
      this.tabis = item
      if(item=='专利布局'){
        this.content ='专利布局是指在对产业、市场以及法律等因素进行综合分析的基础上,有机结合各种专利进而构建一个高效严密的专利保护网,从而使最后形成的专利组合具有有利的格局。专利组合是专利布局的成果,要求具有相当的数量规模,使其具有层级分明、功效齐备的保护网,保障其能在特定的领域中获得专利竞争的优势。'
      } else if(item=='专利价值评估评价'){
        this.content = '专利分析预警是指通过收集与分析本行业技术领域及相关技术领域的专利信息和国内外市场信息，了解竞争对手的行为，把可能发生专利纠纷的前兆及可能产生的危害、建议采取的对策措施及时告知相关政府部门、行业组织及业内企业；同时发布专利权被侵害的信息，建议行业组织和业内企业采取应对措施。'
      }else if(item=='高价值专利组合'){
        this.content = '高价值专利组合是推动产业向价值链高端攀升的有效途径，企业作为技术创新的核心主体，有必要从专利组合成效角度，探寻提高专利集合整体价值的策略性行为，实现保护核心技术、获取先发优势和对抗竞争对手的目标。'
      }else if(item=='产业专利池'){
        this.content = '产业专利池指围绕某一产业，以市场化的运营公司为载体，围绕产业的上中下游筹备建设，通过产业的专利联营、托管、许可、转让、证券化、维权、标准化等实现专利资源的整合，实现保护范围广、规避侵权诉讼、集中运营、持续获利、保障企业和产品"出海"等长期目的。'
      }else if(item=='专利分析预警'){
        this.content = '专利分析预警是指通过收集与分析本行业技术领域及相关技术领域的专利信息和国内外市场信息，了解竞争对手的行为，把可能发生专利纠纷的前兆及可能产生的危害、建议采取的对策措施及时告知相关政府部门、行业组织及业内企业；同时发布专利权被侵害的信息，建议行业组织和业内企业采取应对措施。'
      }else if(item=='专利导航'){
        this.content = '专利导航是在宏观决策、产业规划、企业经营和创新活动中，以专利数据为核心深度融合各类数据资源，全景式分析区域发展定位、产业竞争格局、企业经营决策和技术创新方向，服务创新资源有效配置，提高决策精准度和科学性的新型专利信息应用模式。'
      }else if(item=='知识产权强市强企'){
        this.content = '知识产权强势企业是指在专利、商标、著作权等知识产权的创造、保护、运用和管理各环节形成系统优势，拥有大量高价值核心专利并主导或参与国际标准，能将技术壁垒转化为市场份额和持续盈利，具备全球维权与许可能力，在政府及行业权威评价中处于领先地位的企业。'
      }else if(item=='专利密集型产品'){
        this.content = '专利密集型产品指单位销售额中发明专利密度高、核心专利群覆盖关键技术路径，且专利已成为市场竞争壁垒的终端或中间产品，如5G基站芯片、抗体药物、高端数控机床。其研发投入大、迭代快、侵权风险高，专利许可收益可占利润显著比重。'
      }
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  min-height: calc(100vh - 196px);
  background: #F5F7FA;
}

/* 顶部横幅 */
.banner-section {
  position: relative;
  width: 100%;
  height: 320px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(10, 14, 26, 0.3) 0%, rgba(10, 14, 26, 0.6) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner-text {
  text-align: center;
}

.banner-subtitle {
  font-size: 14px;
  font-weight: 400;
  color: #51A2FF ;
  letter-spacing: 2px;
  margin: 0 0 12px 0;
}

.banner-title {
  font-size: 36px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0 0 32px 0;
}

/* 服务内容区域 */
.services-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  background: #FFFFFF;
}

.services-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 48px;
  background: #F3F4F6;
  border-radius: 50px;
  padding: 10px;
}

.service-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  background: transparent;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 15px;
  color: #9CA3AF;
  font-weight: 500;
  position: relative;
}

.service-tab:hover {
  color: #6B7280;
}

.service-tab.active {
  background: #155DFC;
  color: #FFFFFF;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.tab-icon {
  font-size: 18px;
  font-weight: 400;
}

.service-tab.active .tab-icon {
  font-weight: 600;
}

.tab-text {
  font-size: 15px;
}
.services-content {
  width: 1200px;
}

.content-card {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 48px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  gap: 60px;
}

.card-left {
  flex-shrink: 0;
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.card-icon {
  width: 100px;
  height: 100px;
  background: #EFF6FF;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.card-title {
  font-size: 24px;
  font-weight: 600;
  color: #1F2937;
  margin: 0 0 12px 0;
}

.title-underline {
  width: 60px;
  height: 3px;
  background: #155DFC ;
  border-radius: 2px;
  margin-bottom: 16px;
}

.service-details {
  font-size: 12px;
  color: #9CA3AF;
  letter-spacing: 1px;
  margin: 0;
}

.card-right {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-description {
  font-size: 15px;
  color: #4B5563;
  line-height: 2;
  margin: 0 0 48px 0;
  flex: 1;
}

.service-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-bottom: 48px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: #374151;
  padding: 16px 20px;
  background: #F9FAFB;
  border-radius: 8px;
}

.feature-dot {
  width: 8px;
  height: 8px;
  background: #2B7FFF;
  border-radius: 50%;
}

.consult-btn {
  padding: 14px 36px;
  background: #155DFC ;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
}

.consult-btn:hover {
  background: #2563EB;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
}

.submit-btn-dialog {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  margin-top: 8px;
}

.submit-btn-dialog:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

.dialog-form-content {
  width: 100%;
}
</style>
